import React, {useState} from 'react';
import {View} from "@aws-amplify/ui-react";

function ProgressBar(props) {
    const [color,setColor] = useState('#039dbf')
    const innerStyle={
        width:`${props.now}%`,
        height: '12px',
        backgroundColor: color
    }
    const outerStyle= {
        backgroundColor: '#d9d9d9',
        borderRadius: '6px',
        overflow:'hidden'
    }
    return (
        <View style={outerStyle}>
            <View className={`progress-bar`} variation="info" style={innerStyle}/>
        </View>
    );
}

export default ProgressBar;